import { use } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import SelectField from 'shared/components/formFields/select-field';

import CareConnectSettingsProviderContext from 'features/care-connect-settings/contexts/care-connect-settings-provider-context';
import { RingingStrategy } from 'features/care-connect-settings/domain/models/ringing-strategy';
import styles from 'features/care-connect-settings/views/components/call-plan-ringing-strategy/call-plan-ringing-strategy.module.scss';

const CallPlanRingingStrategy = (): React.JSX.Element => {
  const { t } = useTranslation('careConnectSettings', { keyPrefix: 'callPlanRingingStrategy' });
  const { callPlanDetails } = use(CareConnectSettingsProviderContext);
  const { callPlanForm, isEditing, readCallPlanData } = callPlanDetails;
  const ringingStrategies = Object.values(RingingStrategy).filter((ringingStrategy) => ringingStrategy !== RingingStrategy.Unknown);

  return (
    <div className={styles.container}>
      <Typography variant="h5">{t('title')}</Typography>
      {isEditing ? (
        <Controller
          name="ringingStrategy"
          control={callPlanForm.control}
          rules={{ required: t('fieldRequired') }}
          render={({ field, fieldState: { error } }) => (
            <SelectField {...field} error={!!error} helperText={error?.message} value={field.value ?? ''} variant="outlined">
              {ringingStrategies.map((ringingStrategy) => (
                <MenuItem key={ringingStrategy} value={ringingStrategy}>
                  {t(`options.${ringingStrategy}`)}
                </MenuItem>
              ))}
            </SelectField>
          )}
        />
      ) : (
        <Typography variant="subtitle1">
          {readCallPlanData?.ringingStrategy ? t(`options.${readCallPlanData.ringingStrategy}`) : ''}
        </Typography>
      )}
    </div>
  );
};

export default CallPlanRingingStrategy;
